import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from '@cocoonspace/ui/components/avatar'
import { cn } from '@cocoonspace/ui/lib/utils'
import { UserRoundIcon } from 'lucide-react'

export const AvatarPreview = ({
	avatarUrl,
	className,
}: {
	avatarUrl?: string
	className?: string
}) => (
	<Avatar
		size='xl'
		className={cn('shadow-lg', className)}
	>
		<AvatarImage src={avatarUrl} />

		<AvatarFallback>
			<UserRoundIcon className='text-primary-foreground !size-10' />
		</AvatarFallback>
	</Avatar>
)
